// src/redux/slices/rollenSlice.ts

import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { Rollen, ExpertStatus } from '../../models/Rollen';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../services/firebaseConfig';

interface RollenState {
  rollen: Rollen[];
  loading: boolean;
  error: string | null;
}

const initialState: RollenState = {
  rollen: [],
  loading: false,
  error: null,
};

// Async thunk for updating expert status
export const updateRollenStatus = createAsyncThunk<
  { rolleId: string; status: ExpertStatus },
  { rolleId: string; status: ExpertStatus },
  { rejectValue: string }
>('rollen/updateStatus', async ({ rolleId, status }, { rejectWithValue }) => {
  try {
    const rolleRef = doc(db, 'rollen', rolleId);
    await updateDoc(rolleRef, {
      status,
      updatedAt: new Date().toISOString(),
    });
    return { rolleId, status };
  } catch (error: any) {
    return rejectWithValue('Failed to update expert status');
  }
});

const rollenSlice = createSlice({
  name: 'rollen',
  initialState,
  reducers: {
    setRollen: (state, action: PayloadAction<Rollen[]>) => {
      state.rollen = action.payload;
    },
    clearRollen: state => {
      state.rollen = [];
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(updateRollenStatus.fulfilled, (state, action) => {
      const { rolleId, status } = action.payload;
      const rolle = state.rollen.find(r => r.id === rolleId);
      if (rolle) {
        rolle.status = status;
        rolle.updatedAt = new Date().toISOString();
      }
    });
  },
});

export const { setRollen, clearRollen, setError } = rollenSlice.actions;

export default rollenSlice.reducer;
